<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import BKUserSelect from '@/components/BKUserSelect.vue'
import { Studio, StudioUser, SearchParams } from '@/modules/Studios/types'
import { StudioApi } from '@/enitites/studio'

const props = defineProps<{
  studio: Studio
}>()

const students = ref<StudioUser[]>([])
const paginationParams = ref<SearchParams>({
  pageNumber: 0,
  pageSize: 100,
})

// Computed properties
const excludedStudentIds = computed(() => students.value.map((student) => student.id))

// Students methods
const fetchStudents = async () => {
  if (!props.studio) return
  students.value = await StudioApi.fetchStudioStudents(props.studio.id, paginationParams.value)
}

const addStudent = async (user: StudioUser) => {
  if (!props.studio) return
  const resp = await StudioApi.addStudioStudent(props.studio.id, user.id)
  if (resp) {
    students.value.push(user)
  }
}

const removeStudent = async (user: StudioUser) => {
  if (!props.studio) return
  const resp = await StudioApi.deleteStudioStudentById(props.studio.id, user.id)
  if (resp) {
    students.value = students.value.filter((student) => student.id !== user.id)
  }
}

onMounted(async () => {
  await fetchStudents()
})
</script>

<template>
  <div class="studio-students">
    <p class="students-title">Add students</p>
    <!--eslint-disable  vuejs-accessibility/aria-role-->
    <BKUserSelect
      :exclude="excludedStudentIds"
      :select-user-chip="students"
      label-text="Find students to add"
      role="student"
      @removeUser="removeStudent"
      @selectUser="addStudent"
    />
    <!--eslint-enable  vuejs-accessibility/aria-role-->
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/mixins';

.studio-students {
  width: 100%;
  min-height: 500px;
}

.students-title {
  margin: 12px 0;
  color: var(--color-dark-800);
}
</style>
